var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g7, _g8, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMymemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 648,
    viewBox: "0 0 393 648",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.187 123.818L246.463 106.155L244.242 109.767L272.966 127.43L275.187 123.818Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.966 127.43L244.242 109.767L239.801 116.989L268.524 134.653L272.966 127.43Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.862 124.907L248.346 112.29L243.904 119.513L264.421 132.129L268.862 124.907Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.938 144.746L223.387 106.896L221.166 110.508L282.717 148.357L284.938 144.746Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82 150.88L217.063 107.984L214.842 111.596L284.599 154.492L286.82 150.88Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.703 157.015L210.739 109.073L192.973 137.964L270.936 185.907L288.703 157.015Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.256 121.689L210.739 109.073L206.297 116.296L226.814 128.912L231.256 121.689Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.607 123.865L206.297 116.295L201.856 123.518L214.166 131.088L218.607 123.865Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.703 157.015L268.186 144.399L250.42 173.29L270.937 185.907L288.703 157.015Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.599 175.073L248.875 157.41L242.213 168.244L270.936 185.907L277.599 175.073Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.965 148.01L229.035 125.301L226.814 128.912L263.744 151.622L265.965 148.01Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.848 154.145L222.711 126.389L220.49 130.001L265.627 157.757L267.848 154.145Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.73 160.28L216.387 127.477L209.724 138.311L263.068 171.114L269.73 160.28Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.965 168.591L213.828 140.835L211.607 144.446L256.744 172.203L258.965 168.591Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.64 169.679L215.71 146.97L213.489 150.581L250.42 173.291L252.64 169.679Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.744 151.622L226.814 128.912L224.593 132.524L261.524 155.233L263.744 151.622Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.627 157.756L220.49 130L213.827 140.834L258.964 168.591L265.627 157.756Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.861 166.068L217.931 143.358L215.71 146.969L252.64 169.679L254.861 166.068Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42 152.71L228.697 135.047L226.476 138.658L255.199 156.321L257.42 152.71Z",
    fill: "#2E5F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.303 158.844L222.372 136.135L220.152 139.746L257.082 162.456L259.303 158.844Z",
    fill: "#3A7FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.082 162.456L220.152 139.746L217.931 143.358L254.861 166.067L257.082 162.456Z",
    fill: "#4A9FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.683 143.705L226.476 138.658L224.255 142.27L232.462 147.316L234.683 143.705Z",
    fill: "#6BC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.462 147.316L228.358 144.793L226.138 148.404L230.241 150.928L232.462 147.316Z",
    fill: "#8FD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.275 155.58L265.965 148.01L261.523 155.233L273.834 162.803L278.275 155.58Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.068 150.534L265.965 148.01L263.744 151.622L267.848 154.145L270.068 150.534Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.054 159.192L271.951 156.668L269.73 160.28L273.834 162.803L276.054 159.192Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.373 115.554L221.166 110.508L218.946 114.119L227.152 119.166L229.373 115.554Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.27 113.031L221.166 110.508L218.946 114.119L223.049 116.643L225.27 113.031Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.833 183.384L197.076 140.488L194.855 144.099L264.612 186.995L266.833 183.384Z",
    fill: "#2A2A2A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4925 408.745L39.7401 412.686L41.9885 418.25L51.741 414.309L49.4925 408.745Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.741 414.31L41.9885 418.25L46.4854 429.379L56.2379 425.438L51.741 414.31Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8648 416.28L41.9885 418.25L44.237 423.815L49.1132 421.844L46.8648 416.28Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7471 392.053L37.8709 394.023L44.6163 410.716L49.4925 408.746L42.7471 392.053Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7471 392.053L37.8709 394.023L40.1194 399.588L44.9956 397.617L42.7471 392.053Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.244 403.181L42.3678 405.151L44.6162 410.716L49.4925 408.745L47.244 403.181Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.512 377.218L49.4926 408.746L51.741 414.31L129.761 382.783L127.512 377.218Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.513 378.841L51.741 414.31L56.2379 425.438L144.01 389.97L139.513 378.841Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.258 393.911L56.2379 425.438L58.4864 431.002L136.506 399.475L134.258 393.911Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9983 402.487L56.6172 412.339L58.8656 417.904L83.2468 408.051L80.9983 402.487Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.503 394.605L80.9984 402.487L83.2469 408.051L102.752 400.169L100.503 394.605Z",
    fill: "#A0D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.009 388.346L107.628 398.199L109.876 403.763L134.258 393.911L132.009 388.346Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.381 395.881L109.876 403.763L112.125 409.327L131.63 401.446L129.381 395.881Z",
    fill: "#3A5F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.513 378.842L129.761 382.783L134.258 393.911L144.01 389.97L139.513 378.842Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.389 376.871L139.513 378.842L144.01 389.97L148.886 388L144.389 376.871Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.514 380.465L146.638 382.435L148.886 387.999L153.762 386.029L151.514 380.465Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.389 376.871L139.513 378.842L141.762 384.406L146.638 382.436L144.389 376.871Z",
    fill: "#A0D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.637 380.812L124.884 384.753L127.133 390.317L136.885 386.376L134.637 380.812Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.761 382.782L124.884 384.753L127.133 390.317L132.009 388.347L129.761 382.782Z",
    fill: "#5A8AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2609 366.784L60.0035 378.607L62.252 384.171L91.5094 372.348L89.2609 366.784Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.262 368.407L52.4995 388.112L54.748 393.676L103.51 373.971L101.262 368.407Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.387 372.001L49.8718 395.646L52.1203 401.211L110.635 377.565L108.387 372.001Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.511 375.595L47.244 403.181L49.4925 408.745L117.76 381.159L115.511 375.595Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.76 381.159L49.4924 408.746L51.7409 414.31L120.008 386.723L117.76 381.159Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.757 376.289L62.2521 384.171L64.5005 389.735L84.0054 381.853L81.757 376.289Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1292 383.824L54.748 393.676L56.9965 399.24L81.3776 389.388L79.1292 383.824Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3776 389.388L52.1202 401.211L54.3687 406.775L83.6261 394.952L81.3776 389.388Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.386 372.001L93.7578 377.913L96.0063 383.477L110.635 377.565L108.386 372.001Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.511 375.595L100.883 381.506L103.131 387.071L117.76 381.159L115.511 375.595Z",
    fill: "#3A5F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.754 403.416L58.4863 431.002L60.7348 436.566L129.002 408.98L126.754 403.416Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.126 410.95L65.611 434.596L67.8594 440.16L126.374 416.514L124.126 410.95Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.498 418.485L72.7357 438.189L74.9842 443.754L123.746 424.049L121.498 418.485Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.994 427.99L84.7366 439.812L86.985 445.377L116.242 433.554L113.994 427.99Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9921 424.743L65.611 434.596L67.8594 440.16L92.2405 430.308L89.9921 424.743Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.126 410.95L114.373 414.891L116.622 420.455L126.374 416.514L124.126 410.95Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.498 418.485L111.745 422.426L113.994 427.99L123.746 424.049L121.498 418.485Z",
    fill: "#3A5F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2548 389.041L83.6261 394.952L85.8746 400.516L100.503 394.605L98.2548 389.041Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.249 411.298L92.6199 417.209L94.8683 422.773L109.497 416.862L107.249 411.298Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.503 394.605L85.8745 400.516L92.6199 417.209L107.249 411.297L100.503 394.605Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7507 398.546L85.8745 400.516L92.6199 417.209L97.4961 415.238L90.7507 398.546Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.503 394.605L95.627 396.575L102.372 413.268L107.249 411.297L100.503 394.605Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2459 406.427L66.3696 408.398L68.6181 413.962L73.4943 411.992L71.2459 406.427Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9983 402.487L76.1221 404.457L78.3705 410.021L83.2467 408.051L80.9983 402.487Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.256 390.664L105.379 392.634L107.628 398.198L112.504 396.228L110.256 390.664Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.008 386.723L115.132 388.693L117.38 394.258L122.257 392.287L120.008 386.723Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8077 407.413L66.3696 408.398L67.4939 411.18L69.932 410.195L68.8077 407.413Z",
    fill: "#5A8AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5602 403.472L76.1221 404.457L77.2463 407.239L79.6844 406.254L78.5602 403.472Z",
    fill: "#5A8AAA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.331 450.5L261.66 386.988L259.596 391.366L394.266 454.879L396.331 450.5Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.94 393.415L259.596 391.367L243.077 426.392L247.421 428.441L263.94 393.415Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.266 454.878L389.922 452.83L373.404 487.855L377.748 489.904L394.266 454.878Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.748 489.904L243.077 426.392L241.012 430.77L375.683 494.282L377.748 489.904Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.922 452.83L263.94 393.416L247.421 428.441L373.404 487.855L389.922 452.83Z",
    fill: "#F5EAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.349 407.757L263.94 393.416L247.421 428.441L277.831 442.782L294.349 407.757Z",
    fill: "#F0E6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.489 410.97L293.317 409.946L292.284 412.135L294.457 413.159L295.489 410.97Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.424 415.349L291.252 414.324L290.22 416.513L292.392 417.538L293.424 415.349Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.359 419.727L289.187 418.702L288.155 420.891L290.327 421.916L291.359 419.727Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.295 424.105L287.123 423.081L286.09 425.27L288.262 426.294L289.295 424.105Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.23 428.483L285.058 427.458L284.025 429.648L286.197 430.672L287.23 428.483Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.165 432.861L282.993 431.837L281.961 434.026L284.133 435.05L285.165 432.861Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.1 437.239L280.928 436.215L279.896 438.404L282.068 439.428L283.1 437.239Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.035 441.618L278.863 440.593L277.831 442.782L280.003 443.807L281.035 441.618Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.778 412.697L266.434 410.648L264.369 415.026L268.713 417.075L270.778 412.697Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.467 416.794L270.778 412.696L268.713 417.074L277.402 421.172L279.467 416.794Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.811 418.843L279.467 416.794L277.402 421.172L281.746 423.221L283.811 418.843Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.187 410.367L268.499 406.27L266.434 410.648L275.122 414.745L277.187 410.367Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.057 419.123L264.369 415.026L262.304 419.404L270.993 423.502L273.057 419.123Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.35 424.428L300.973 416.232L298.908 420.611L316.285 428.806L318.35 424.428Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.973 432.903L298.908 420.611L296.843 424.989L322.909 437.282L324.973 432.903Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.695 443.147L333.662 437.001L331.597 441.379L344.63 447.525L346.695 443.147Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.759 438.769L344.415 436.72L342.35 441.098L346.694 443.147L348.759 438.769Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63 447.525L340.285 445.477L338.221 449.855L342.565 451.904L344.63 447.525Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.824 451.062L357.448 442.867L355.383 447.245L372.76 455.44L374.824 451.062Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.104 457.489L355.383 447.245L353.318 451.623L375.039 461.867L377.104 457.489Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.746 439.891L292.714 433.745L290.649 438.123L303.682 444.27L305.746 439.891Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.467 450.136L310.091 441.94L308.026 446.319L325.403 454.514L327.467 450.136Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.844 458.33L336.156 454.233L334.091 458.611L342.78 462.709L344.844 458.33Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.221 466.526L349.188 460.379L347.124 464.758L360.156 470.904L362.221 466.526Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.789 441.337L289.617 440.312L286.519 446.88L288.691 447.904L291.789 441.337Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.305 444.41L293.961 442.361L290.864 448.929L295.208 450.977L298.305 444.41Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.649 446.459L300.477 445.435L297.38 452.002L299.552 453.026L302.649 446.459Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.993 448.508L304.821 447.483L301.724 454.051L303.896 455.075L306.993 448.508Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.51 451.581L309.166 449.532L306.068 456.099L310.413 458.148L313.51 451.581Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.854 453.629L315.682 452.605L312.585 459.172L314.757 460.197L317.854 453.629Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.37 456.703L320.026 454.654L316.929 461.221L321.273 463.27L324.37 456.703Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.714 458.751L326.542 457.727L323.445 464.294L325.617 465.319L328.714 458.751Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.059 460.8L330.887 459.776L327.789 466.343L329.962 467.368L333.059 460.8Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 463.873L335.231 461.825L332.134 468.392L336.478 470.441L339.575 463.873Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.919 465.922L341.747 464.898L338.65 471.465L340.822 472.49L343.919 465.922Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.263 467.971L346.091 466.947L342.994 473.514L345.166 474.538L348.263 467.971Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78 471.044L350.436 468.996L347.338 475.563L351.683 477.612L354.78 471.044Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.124 473.093L356.952 472.068L353.855 478.636L356.027 479.66L359.124 473.093Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.64 476.166L361.296 474.117L358.199 480.684L362.543 482.733L365.64 476.166Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.207 425.971L254.863 423.922L252.798 428.301L257.142 430.349L259.207 425.971Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.068 431.093L261.379 426.996L259.314 431.374L268.003 435.471L270.068 431.093Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.584 434.166L272.24 432.118L270.175 436.496L274.519 438.545L276.584 434.166Z",
    fill: "#9A9A9A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90565 494.215L-73.5104 537.798L-70.9468 542.293L5.46931 498.711L2.90565 494.215Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96438 496.147L-75.4418 544.856L-44.6778 598.797L40.7284 550.088L9.96438 496.147Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2333 552.651L-40.1827 596.233L-35.0554 605.224L41.3607 561.641L36.2333 552.651Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96439 496.147L-12.5109 508.965L18.2531 562.906L40.7284 550.087L9.96439 496.147Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0374 536.602L1.57196 554.548L9.26297 568.033L40.7284 550.087L33.0374 536.602Z",
    fill: "#A0440D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.324865 519.887L-49.7706 548.087L-34.3886 575.057L15.0571 546.857L-0.324865 519.887Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5621 549.421L-29.8935 572.494L-27.3298 576.989L13.1257 553.916L10.5621 549.421Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.324869 519.887L-13.8101 527.578L1.57195 554.548L15.0571 546.857L-0.324869 519.887Z",
    fill: "#A0440D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8657 564.205L-30.5603 602.66L-27.9966 607.155L39.4293 568.7L36.8657 564.205Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9342 571.264L-23.5016 604.592L-18.3743 613.582L40.0616 580.254L34.9342 571.264Z",
    fill: "#A0440D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5666 582.818L-13.8792 611.018L-11.3155 615.513L38.1302 587.313L35.5666 582.818Z",
    fill: "#8A3A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5894 496.779L-10.5795 501.906L30.4392 573.827L39.4293 568.7L-1.5894 496.779Z",
    fill: "#8A6A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.08447 499.343L-10.5795 501.906L30.4392 573.827L34.9342 571.264L-6.08447 499.343Z",
    fill: "#9A7A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29038 507.051L-0.957153 508.333L29.8069 562.273L32.0544 560.991L1.29038 507.051Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3563 528.244L7.36615 533.372L12.4935 542.362L21.4836 537.234L16.3563 528.244Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8612 530.808L7.36615 533.372L9.92982 537.867L14.4249 535.303L11.8612 530.808Z",
    fill: "#8A8A8A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.804 531.854L208.563 505.823L205.671 509.85L241.912 535.88L244.804 531.854Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.966 541.665L197.618 504.065L194.725 508.092L247.073 545.692L249.966 541.665Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.127 551.476L186.672 502.308L183.779 506.334L252.235 555.503L255.127 551.476Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.261 558.395L179.753 503.442L176.86 507.469L253.369 562.422L256.261 558.395Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.396 565.314L172.834 504.577L167.049 512.63L251.611 573.368L257.396 565.314Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.076 515.523L167.049 512.63L141.019 548.871L145.046 551.764L171.076 515.523Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.611 573.368L247.584 570.476L221.554 606.716L225.581 609.609L251.611 573.368Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.581 609.609L141.019 548.871L135.234 556.925L219.796 617.662L225.581 609.609Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.77 614.77L139.261 559.817L136.369 563.844L212.877 618.797L215.77 614.77Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.851 615.904L140.396 566.736L137.503 570.763L205.958 619.931L208.851 615.904Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.905 614.147L145.557 576.547L142.665 580.574L195.013 618.174L197.905 614.147Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.959 612.389L150.718 586.358L147.826 590.385L184.067 616.416L186.959 612.389Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.912 535.881L205.671 509.851L202.779 513.877L239.02 539.908L241.912 535.881Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.073 545.692L194.725 508.093L191.833 512.12L244.181 549.719L247.073 545.692Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.235 555.503L183.78 506.335L180.887 510.362L249.342 559.53L252.235 555.503Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.369 562.422L176.86 507.469L171.076 515.523L247.585 570.476L253.369 562.422Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.103 518.415L171.076 515.523L145.046 551.764L149.072 554.656L175.103 518.415Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.585 570.476L243.558 567.583L217.527 603.824L221.554 606.717L247.585 570.476Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.554 606.717L145.046 551.764L139.261 559.817L215.77 614.77L221.554 606.717Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.743 611.878L143.288 562.709L140.396 566.736L208.851 615.905L211.743 611.878Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.797 610.12L148.449 572.521L145.557 576.548L197.905 614.147L200.797 610.12Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.851 608.363L153.61 582.333L150.718 586.359L186.959 612.39L189.851 608.363Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.859 522.554L194.725 508.093L191.833 512.12L211.967 526.581L214.859 522.554Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94 523.689L183.78 506.335L180.887 510.362L205.048 527.715L207.94 523.689Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.048 527.715L176.86 507.469L171.076 515.523L199.263 535.769L205.048 527.715Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.02 539.907L202.779 513.877L199.887 517.904L236.127 543.934L239.02 539.907Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.181 549.719L191.833 512.12L188.941 516.146L241.289 553.746L244.181 549.719Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.316 556.638L184.914 513.254L179.13 521.307L239.531 564.691L245.316 556.638Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.558 567.583L175.103 518.415L149.072 554.656L217.527 603.824L243.558 567.583Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.501 600.932L153.099 557.548L147.315 565.602L207.716 608.986L213.501 600.932Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.689 606.094L151.341 568.494L148.449 572.521L200.797 610.12L203.689 606.094Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.744 604.336L156.503 578.306L153.61 582.332L189.851 608.363L192.744 604.336Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.101 533.5L209.075 530.607L200.398 542.688L204.425 545.58L213.101 533.5Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.128 536.392L213.101 533.5L210.209 537.526L214.236 540.419L217.128 536.392Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.263 543.311L214.236 540.419L208.451 548.472L212.478 551.365L218.263 543.311Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34 583.579L177.26 574.902L174.367 578.929L186.448 587.605L189.34 583.579Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.394 581.821L174.367 578.929L171.475 582.955L175.502 585.848L178.394 581.821Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.555 591.632L175.502 585.848L172.61 589.874L180.663 595.659L183.555 591.632Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.663 595.659L176.636 592.767L173.744 596.793L177.771 599.686L180.663 595.659Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.854 576.771L222.801 570.987L219.908 575.014L227.962 580.798L230.854 576.771Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.935 577.906L219.908 575.014L217.016 579.04L221.043 581.933L223.935 577.906Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.07 584.825L217.016 579.041L214.124 583.067L222.177 588.852L225.07 584.825Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.479 536.28L170.453 533.388L161.776 545.468L165.803 548.36L174.479 536.28Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.614 543.199L171.587 540.307L168.695 544.333L172.722 547.226L175.614 543.199Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.533 542.065L178.506 539.172L169.829 551.253L173.856 554.145L182.533 542.065Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.559 552.499L201.532 549.606L198.64 553.633L202.667 556.525L205.559 552.499Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.667 556.526L198.64 553.633L195.748 557.66L199.775 560.552L202.667 556.526Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.801 563.445L191.721 554.768L188.829 558.795L200.909 567.472L203.801 563.445Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.775 560.552L195.748 557.66L192.856 561.687L196.882 564.579L199.775 560.552Z",
    fill: "#FF6B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.909 567.471L188.829 558.794L185.936 562.821L198.017 571.498L200.909 567.471Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.99 568.606L189.963 565.713L187.071 569.74L191.098 572.632L193.99 568.606Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.098 572.632L187.071 569.74L184.179 573.767L188.206 576.659L191.098 572.632Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.774 560.552L195.748 557.66L189.963 565.714L193.99 568.606L199.774 560.552Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.748 557.66L191.721 554.768L188.829 558.795L192.855 561.687L195.748 557.66Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.909 567.472L196.882 564.58L193.99 568.606L198.017 571.499L200.909 567.472Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.344 544.445L207.317 541.553L204.425 545.58L208.451 548.472L211.344 544.445Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.313 580.686L181.286 577.794L178.394 581.821L182.421 584.713L185.313 580.686Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.667 548.983L179.641 546.091L176.748 550.118L180.775 553.01L183.667 548.983Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.908 575.013L215.882 572.121L212.989 576.148L217.016 579.04L219.908 575.013Z",
    fill: "#6A6A6A"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.725 263.703L125.158 267.125L128.886 272.101L133.453 268.679L129.725 263.703Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.859 256.859L134.292 260.281L138.02 265.257L142.588 261.835L138.859 256.859Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.994 250.015L143.427 253.437L147.155 258.413L151.722 254.991L147.994 250.015Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.128 243.171L152.561 246.593L156.289 251.569L160.856 248.147L157.128 243.171Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.262 236.328L161.695 239.75L165.423 244.725L169.991 241.304L166.262 236.328Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.397 229.483L170.829 232.905L174.558 237.881L179.125 234.459L175.397 229.483Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.531 222.64L179.964 226.062L183.692 231.037L188.259 227.616L184.531 222.64Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.886 272.101L124.319 275.523L128.047 280.499L132.615 277.077L128.886 272.101Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.343 282.053L131.776 285.475L135.504 290.451L140.071 287.029L136.343 282.053Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.799 292.005L139.232 295.427L142.96 300.403L147.528 296.981L143.799 292.005Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.256 301.957L146.689 305.379L150.417 310.355L154.984 306.933L151.256 301.957Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.712 311.909L154.145 315.331L157.873 320.307L162.441 316.885L158.712 311.909Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.169 321.861L161.602 325.283L165.33 330.259L169.897 326.837L166.169 321.861Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.625 331.812L169.058 335.234L172.786 340.21L177.354 336.788L173.625 331.812Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.082 341.765L176.515 345.187L180.243 350.162L184.81 346.741L181.082 341.765Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.538 351.716L183.971 355.138L187.699 360.114L192.267 356.692L188.538 351.716Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.394 220.772L192.826 224.194L196.555 229.17L201.122 225.748L197.394 220.772Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.85 230.724L200.283 234.146L204.011 239.122L208.578 235.7L204.85 230.724Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.307 240.676L207.74 244.098L211.468 249.074L216.035 245.652L212.307 240.676Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.763 250.628L215.196 254.05L218.924 259.026L223.491 255.604L219.763 250.628Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22 260.58L222.652 264.001L226.381 268.977L230.948 265.555L227.22 260.58Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.676 270.532L230.109 273.954L233.837 278.93L238.404 275.508L234.676 270.532Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.133 280.483L237.566 283.905L241.294 288.881L245.861 285.459L242.133 280.483Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.589 290.435L245.022 293.857L248.75 298.833L253.317 295.411L249.589 290.435Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.046 300.387L252.479 303.809L256.207 308.785L260.774 305.363L257.046 300.387Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.562 358.247L195.995 361.668L199.723 366.644L204.29 363.222L200.562 358.247Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.696 351.403L205.129 354.825L208.857 359.801L213.425 356.379L209.696 351.403Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.831 344.559L214.264 347.98L217.992 352.956L222.559 349.534L218.831 344.559Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.965 337.715L223.398 341.137L227.126 346.113L231.693 342.691L227.965 337.715Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.099 330.871L232.532 334.293L236.26 339.269L240.828 335.847L237.099 330.871Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.234 324.027L241.666 327.449L245.395 332.425L249.962 329.003L246.234 324.027Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.368 317.183L250.801 320.605L254.529 325.581L259.096 322.159L255.368 317.183Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.826 224.194L128.886 272.101L195.995 361.668L259.935 313.761L192.826 224.194Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.722 254.991L128.886 272.101L136.343 282.053L159.179 264.943L151.722 254.991Z",
    fill: "#FF6B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.179 264.943L140.91 278.631L148.366 288.583L166.635 274.895L159.179 264.943Z",
    fill: "#FF8577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.283 234.146L186.581 244.412L246.234 324.027L259.935 313.761L200.283 234.146Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.75 298.833L225.915 315.943L237.099 330.871L259.935 313.761L248.75 298.833Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.836 256L190.567 269.688L194.295 274.664L212.564 260.976L208.836 256Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.564 260.976L189.728 278.086L193.457 283.062L216.292 265.952L212.564 260.976Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.292 265.952L193.457 283.062L204.641 297.99L227.477 280.88L216.292 265.952Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.477 280.88L209.208 294.568L220.393 309.496L238.662 295.808L227.477 280.88Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.095 299.23L220.393 309.496L227.85 319.448L241.551 309.182L234.095 299.23Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.551 309.181L232.417 316.025L236.145 321.001L245.279 314.157L241.551 309.181Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.253 293.245L168.686 296.667L172.414 301.643L176.981 298.221L173.253 293.245Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.981 298.221L167.847 305.065L171.575 310.041L180.709 303.197L176.981 298.221Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.142 306.619L171.575 310.041L175.303 315.017L179.87 311.595L176.142 306.619Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.709 303.197L176.142 306.619L179.87 311.595L184.438 308.173L180.709 303.197Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.438 308.173L175.303 315.017L179.031 319.993L188.166 313.149L184.438 308.173Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.166 313.149L183.599 316.571L187.327 321.547L191.894 318.125L188.166 313.149Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.783 331.498L190.216 334.92L197.673 344.872L202.24 341.45L194.783 331.498Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.918 324.655L194.783 331.499L198.512 336.475L207.646 329.631L203.918 324.655Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.079 333.053L198.512 336.475L202.24 341.451L206.807 338.029L203.079 333.053Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.374 334.606L202.24 341.45L205.968 346.426L215.102 339.582L211.374 334.606Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.619 314.389L208.485 321.232L212.213 326.208L221.347 319.364L217.619 314.389Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78 322.787L212.213 326.208L215.941 331.184L220.508 327.763L216.78 322.787Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.076 324.341L215.941 331.185L219.67 336.161L228.804 329.317L225.076 324.341Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.321 304.123L222.186 310.967L225.915 315.943L235.049 309.099L231.321 304.123Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.049 309.099L225.915 315.943L229.643 320.919L238.777 314.075L235.049 309.099Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.777 314.075L229.643 320.918L233.371 325.894L242.505 319.051L238.777 314.075Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.31 249.388L185.743 252.81L193.199 262.762L197.766 259.34L190.31 249.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.333 255.918L193.199 262.762L196.927 267.738L206.062 260.894L202.333 255.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.605 250.942L194.038 254.364L197.766 259.34L202.333 255.918L198.605 250.942Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1867 253.348L12.0018 245.442L4.30686 253.41L12.4917 261.315L20.1867 253.348Z",
    fill: "#FFD700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 261.283L4.06189 245.473L0.214406 249.457L16.5842 265.267L20.4316 261.283Z",
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2716 229.446L35.0867 221.541L31.2392 225.524L39.4241 233.429L43.2716 229.446Z",
    fill: "#CCAC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4241 233.429L31.2392 225.524L27.3917 229.508L35.5766 237.413L39.4241 233.429Z",
    fill: "#FFD700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6691 241.365L23.2993 225.555L19.4518 229.539L35.8216 245.349L39.6691 241.365Z",
    fill: "#FFD700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8216 245.349L19.4518 229.539L15.6044 233.522L31.9741 249.332L35.8216 245.349Z",
    fill: "#FFD700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9741 249.333L15.6043 233.522L11.7568 237.506L28.1266 253.316L31.9741 249.333Z",
    fill: "#FFD700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1266 253.316L11.7568 237.506L7.90935 241.489L24.2791 257.3L28.1266 253.316Z",
    fill: "#FFD700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3316 229.476L31.2392 225.524L27.3917 229.508L31.4842 233.46L35.3316 229.476Z",
    fill: "#FFED4E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4842 233.46L23.2993 225.555L19.4518 229.539L27.6367 237.444L31.4842 233.46Z",
    fill: "#FFE44D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6367 237.444L19.4518 229.539L15.6044 233.522L23.7892 241.427L27.6367 237.444Z",
    fill: "#FFF266"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6691 241.366L31.4842 233.46L27.6367 237.444L35.8216 245.349L39.6691 241.366Z",
    fill: "#DDB900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8216 245.349L27.6367 237.444L23.7892 241.427L31.9741 249.333L35.8216 245.349Z",
    fill: "#CCAA00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0665 253.285L31.9741 249.333L28.1266 253.316L32.219 257.269L36.0665 253.285Z",
    fill: "#FFD700"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.159 257.238L36.0665 253.285L32.219 257.269L36.3115 261.221L40.159 257.238Z",
    fill: "#FFD700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4039 265.174L36.3115 261.221L32.464 265.205L36.5564 269.157L40.4039 265.174Z",
    fill: "#FFD700"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4964 269.126L40.4039 265.174L36.5564 269.157L40.6489 273.11L44.4964 269.126Z",
    fill: "#CCAC00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0665 253.285L31.9741 249.333L28.1266 253.316L32.219 257.269L36.0665 253.285Z",
    fill: "#FFE44D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4039 265.174L36.3115 261.221L32.464 265.205L36.5564 269.157L40.4039 265.174Z",
    fill: "#DDB900"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3716 261.252L24.2791 257.3L16.5841 265.267L20.6766 269.22L28.3716 261.252Z",
    fill: "#FFD700"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.464 265.205L28.3716 261.252L20.6766 269.22L24.7691 273.172L32.464 265.205Z",
    fill: "#FFD700"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.709 273.141L28.6165 269.188L24.769 273.172L28.8615 277.125L32.709 273.141Z",
    fill: "#FFD700"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8014 277.094L32.7089 273.141L28.8614 277.125L32.9539 281.077L36.8014 277.094Z",
    fill: "#FFD700"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8938 281.046L36.8014 277.094L32.9539 281.077L37.0463 285.03L40.8938 281.046Z",
    fill: "#FFD700"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9862 284.999L40.8938 281.046L37.0463 285.03L41.1388 288.983L44.9862 284.999Z",
    fill: "#CCAC00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.464 265.205L28.3716 261.252L20.6766 269.22L24.7691 273.172L32.464 265.205Z",
    fill: "#DDB900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8014 277.094L32.7089 273.141L28.8614 277.125L32.9539 281.077L36.8014 277.094Z",
    fill: "#CCAA00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8938 281.046L36.8014 277.094L32.9539 281.077L37.0463 285.03L40.8938 281.046Z",
    fill: "#CCAA00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8291 273.204L12.7367 269.251L8.88921 273.235L12.9817 277.187L16.8291 273.204Z",
    fill: "#FFD700"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9216 277.156L16.8292 273.204L12.9817 277.187L17.0741 281.14L20.9216 277.156Z",
    fill: "#FFD700"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0741 281.14L12.9816 277.187L9.13415 281.171L13.2266 285.123L17.0741 281.14Z",
    fill: "#FFD700"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 285.092L17.0741 281.14L13.2266 285.123L17.3191 289.076L21.1665 285.092Z",
    fill: "#FFD700"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3191 289.076L13.2266 285.124L9.37914 289.107L13.4716 293.06L17.3191 289.076Z",
    fill: "#CCAC00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9216 277.156L16.8292 273.204L12.9817 277.187L17.0741 281.14L20.9216 277.156Z",
    fill: "#DDB900"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 285.092L17.0741 281.14L13.2266 285.123L17.3191 289.076L21.1665 285.092Z",
    fill: "#CCAA00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7366 269.251L-3.63312 253.44L-7.4806 257.424L8.88916 273.234L12.7366 269.251Z",
    fill: "#FFD700"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88917 273.234L-7.48059 257.424L-11.3281 261.407L5.04168 277.218L8.88917 273.234Z",
    fill: "#FFD700"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0417 277.218L-11.3281 261.408L-15.1755 265.391L1.19421 281.202L5.0417 277.218Z",
    fill: "#FFD700"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55176 261.346L-3.63312 253.44L-7.4806 257.424L0.704279 265.329L4.55176 261.346Z",
    fill: "#FFF266"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7366 269.251L4.55176 261.346L0.704274 265.329L8.88915 273.234L12.7366 269.251Z",
    fill: "#DDB900"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88916 273.234L0.704285 265.329L-3.1432 269.313L5.04168 277.218L8.88916 273.234Z",
    fill: "#CCAA00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04169 277.218L-3.14319 269.313L-6.99067 273.297L1.19421 281.202L5.04169 277.218Z",
    fill: "#CCAA00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9094 241.49L3.81696 237.537L-3.87801 245.504L0.214429 249.457L7.9094 241.49Z",
    fill: "#FFD700"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81693 237.537L-0.275513 233.584L-7.97048 241.552L-3.87804 245.504L3.81693 237.537Z",
    fill: "#FFD700"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9094 241.49L3.81696 237.537L-3.87801 245.504L0.214429 249.457L7.9094 241.49Z",
    fill: "#FFE44D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81693 237.537L-0.275513 233.584L-7.97048 241.552L-3.87804 245.504L3.81693 237.537Z",
    fill: "#FFF68F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6043 233.522L11.5119 229.57L7.66442 233.553L11.7569 237.506L15.6043 233.522Z",
    fill: "#FFD700"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5119 229.57L7.41943 225.617L3.57195 229.601L7.66439 233.553L11.5119 229.57Z",
    fill: "#FFD700"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57193 229.601L-0.520508 225.648L-4.36799 229.632L-0.275551 233.584L3.57193 229.601Z",
    fill: "#FFD700"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6043 233.522L11.5119 229.57L7.66442 233.553L11.7569 237.506L15.6043 233.522Z",
    fill: "#FFE44D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5119 229.57L7.41943 225.617L3.57195 229.601L7.66439 233.553L11.5119 229.57Z",
    fill: "#FFF68F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M31.4842 233.46L27.3918 229.508L23.5443 233.491L27.6367 237.444L31.4842 233.46Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.0018 245.442L7.90936 241.49L4.06188 245.473L8.15432 249.426L12.0018 245.442Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.3392 257.331L12.2468 253.378L8.39928 257.362L12.4917 261.315L16.3392 257.331Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7567 87.7351L34.5274 89.9287L35.6242 92.5433L40.8535 90.3497L39.7567 87.7351Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8535 90.3497L33.0096 93.6401L34.1064 96.2548L41.9503 92.9643L40.8535 90.3497Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9504 92.9644L34.1064 96.2549L36.3001 101.484L44.144 98.1937L41.9504 92.9644Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.144 98.1934L36.3 101.484L37.3969 104.099L45.2408 100.808L44.144 98.1934Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2407 100.808L40.0115 103.002L41.1083 105.617L46.3376 103.423L45.2407 100.808Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6242 92.5433L33.0096 93.6401L34.1064 96.2548L36.721 95.158L35.6242 92.5433Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7211 95.1581L34.1064 96.2549L36.3001 101.484L38.9147 100.387L36.7211 95.1581Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9762 71.2824L73.7469 73.4761L74.8438 76.0907L80.073 73.8971L78.9762 71.2824Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6877 72.8004L74.8438 76.0908L75.9406 78.7055L83.7845 75.415L82.6877 72.8004Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7845 75.4151L75.9406 78.7056L78.1342 83.9348L85.9781 80.6444L83.7845 75.4151Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9782 80.6441L78.1343 83.9346L79.2311 86.5492L87.075 83.2587L85.9782 80.6441Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4604 84.3557L79.2311 86.5493L80.3279 89.164L85.5572 86.9703L84.4604 84.3557Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6876 72.8002L80.073 73.897L81.1698 76.5116L83.7845 75.4148L82.6876 72.8002Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7846 75.4149L81.1699 76.5117L83.3636 81.741L85.9782 80.6442L83.7846 75.4149Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9387 69.3437L40.1777 81.4087L41.2746 84.0233L70.0356 71.9583L68.9387 69.3437Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6501 70.8614L38.6599 85.1201L39.7567 87.7348L73.747 73.4761L72.6501 70.8614Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0355 71.9579L41.2745 84.0229L42.3714 86.6376L71.1324 74.5725L70.0355 71.9579Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7469 73.4762L39.7567 87.7349L40.8535 90.3495L74.8438 76.0908L73.7469 73.4762Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8438 76.0909L40.8535 90.3496L41.9503 92.9642L75.9406 78.7056L74.8438 76.0909Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3259 79.8021L44.5649 91.8672L45.6618 94.4818L74.4228 82.4168L73.3259 79.8021Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4228 82.4169L45.6617 94.4819L46.7586 97.0966L75.5196 85.0315L74.4228 82.4169Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9049 86.1286L49.3732 96L50.47 98.6146L74.0017 88.7432L72.9049 86.1286Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0018 88.7429L50.4701 98.6143L51.5669 101.229L75.0986 91.3575L74.0018 88.7429Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.484 92.4546L54.1815 100.132L55.2783 102.747L73.5808 95.0692L72.484 92.4546Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5808 95.0693L55.2783 102.747L56.3751 105.362L74.6776 97.684L73.5808 95.0693Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0629 98.7805L58.9897 104.265L60.0866 106.879L73.1598 101.395L72.0629 98.7805Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 84.4445L42.3713 86.6382L43.4682 89.2528L48.6974 87.0592L47.6006 84.4445Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3121 85.962L43.4681 89.2524L44.565 91.8671L52.4089 88.5766L51.3121 85.962Z",
    fill: "#FFF266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0235 87.48L47.1796 90.7705L48.2764 93.3851L56.1203 90.0947L55.0235 87.48Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7349 88.998L48.2764 93.3853L49.3732 95.9999L59.8317 91.6126L58.7349 88.998Z",
    fill: "#FFFAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8317 91.6124L51.9878 94.9028L53.0846 97.5175L60.9285 94.227L59.8317 91.6124Z",
    fill: "#FFFAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.314 95.3239L53.0847 97.5176L54.1815 100.132L59.4108 97.9386L58.314 95.3239Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.747 73.4761L65.9031 76.7666L66.9999 79.3812L74.8438 76.0908L73.747 73.4761Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2292 77.1876L64.3853 80.478L65.4821 83.0927L73.326 79.8022L72.2292 77.1876Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.326 79.8023L65.4821 83.0928L66.5789 85.7074L74.4228 82.4169L73.326 79.8023Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8081 83.5137L63.9642 86.8042L65.0611 89.4188L72.905 86.1284L71.8081 83.5137Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9049 86.1285L65.061 89.4189L66.1579 92.0336L74.0018 88.7431L72.9049 86.1285Z",
    fill: "#BB9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3871 89.84L66.1578 92.0337L67.2547 94.6483L72.4839 92.4547L71.3871 89.84Z",
    fill: "#BB9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7744 100.298L57.4719 107.976L58.5687 110.591L76.8712 102.913L75.7744 100.298Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1597 101.395L60.0865 106.879L61.1834 109.494L74.2566 104.01L73.1597 101.395Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.642 105.107L63.7981 108.397L64.8949 111.012L72.7388 107.721L71.642 105.107Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7388 107.721L64.8949 111.012L65.9917 113.626L73.8356 110.336L72.7388 107.721Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8356 110.336L65.9917 113.626L68.1853 118.856L76.0293 115.565L73.8356 110.336Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0293 115.565L68.1854 118.855L69.2822 121.47L77.1262 118.18L76.0293 115.565Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5095 109.915L64.8949 111.012L65.9917 113.626L68.6064 112.53L67.5095 109.915Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6063 112.53L65.9917 113.626L68.1853 118.856L70.8 117.759L68.6063 112.53Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7388 107.721L70.1241 108.818L71.221 111.433L73.8356 110.336L72.7388 107.721Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8357 110.336L71.2211 111.433L73.4147 116.662L76.0293 115.565L73.8357 110.336Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7407 117.083L66.6675 122.567L67.7643 125.182L80.8375 119.697L79.7407 117.083Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4521 118.601L65.1497 126.278L66.2465 128.893L84.5489 121.215L83.4521 118.601Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8375 119.698L67.7643 125.182L68.8611 127.796L81.9343 122.312L80.8375 119.698Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1636 120.118L63.6318 129.99L64.7287 132.604L88.2604 122.733L87.1636 120.118Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.875 121.636L62.114 133.701L63.2108 136.316L91.9718 124.251L90.875 121.636Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9719 124.251L63.2109 136.316L64.3078 138.931L93.0688 126.866L91.9719 124.251Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8611 127.796L63.6318 129.99L64.7287 132.604L69.9579 130.411L68.8611 127.796Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9579 130.411L62.114 133.701L63.2108 136.316L71.0547 133.025L69.9579 130.411Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1636 120.119L79.3197 123.409L80.4165 126.024L88.2604 122.733L87.1636 120.119Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.875 121.636L83.0311 124.927L84.1279 127.541L91.9719 124.251L90.875 121.636Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.972 124.251L84.1281 127.542L85.2249 130.156L93.0688 126.866L91.972 124.251Z",
    fill: "#BB9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6834 125.769L61.6931 140.028L62.7899 142.642L96.7802 128.384L95.6834 125.769Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0687 126.866L64.3077 138.931L65.4046 141.545L94.1656 129.48L93.0687 126.866Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3948 127.287L60.1753 143.739L61.2721 146.354L100.492 129.902L99.3948 127.287Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7802 128.383L62.7899 142.642L63.8867 145.257L97.877 130.998L96.7802 128.383Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M48.6974 87.0589L46.0828 88.1558L47.1796 90.7704L49.7942 89.6736L48.6974 87.0589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.4088 88.5765L49.7942 89.6733L50.891 92.288L53.5056 91.1912L52.4088 88.5765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M55.4445 81.1537L52.8298 82.2505L53.9267 84.8651L56.5413 83.7683L55.4445 81.1537Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.566 220.13L321.72 230.068L323.228 233.382L345.073 223.443L343.566 220.13Z",
    fill: "#8B6F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.315 220.604L316.986 236.221L318.494 239.534L352.822 223.917L351.315 220.604Z",
    fill: "#9D7D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.064 221.078L312.252 242.374L313.759 245.687L360.571 224.391L359.064 221.078Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.813 221.551L307.518 248.526L309.025 251.84L368.32 224.864L366.813 221.551Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.562 222.025L302.783 254.679L304.291 257.992L376.069 225.338L374.562 222.025Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.19 223.918L301.17 259.413L302.677 262.726L380.697 227.232L379.19 223.918Z",
    fill: "#D4B587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.818 225.812L299.556 264.146L301.064 267.459L385.325 229.125L383.818 225.812Z",
    fill: "#D4B587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.446 227.705L297.943 268.878L299.45 272.192L389.953 231.018L388.446 227.705Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.074 229.599L296.329 273.611L297.837 276.925L394.581 232.912L393.074 229.599Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.581 232.912L297.837 276.925L299.344 280.238L396.089 236.225L394.581 232.912Z",
    fill: "#8B6F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.832 226.283L323.228 233.381L324.735 236.695L340.339 229.596L338.832 226.283Z",
    fill: "#E8D4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.339 229.596L318.493 239.534L320.001 242.847L341.846 232.909L340.339 229.596Z",
    fill: "#DCC797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.846 232.909L313.759 245.687L315.266 249L343.354 236.222L341.846 232.909Z",
    fill: "#D4BA8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.354 236.222L309.025 251.84L310.532 255.153L344.861 239.536L343.354 236.222Z",
    fill: "#CCB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.064 221.077L343.46 228.176L344.967 231.49L360.571 224.391L359.064 221.077Z",
    fill: "#9D7D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.813 221.551L351.209 228.65L352.716 231.963L368.32 224.864L366.813 221.551Z",
    fill: "#8B6F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.562 222.025L358.958 229.124L360.465 232.437L376.069 225.338L374.562 222.025Z",
    fill: "#7A5F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.19 223.918L366.707 229.597L368.214 232.91L380.697 227.231L379.19 223.918Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.818 225.812L374.455 230.071L375.963 233.384L385.325 229.125L383.818 225.812Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.446 227.705L379.084 231.964L380.591 235.278L389.953 231.018L388.446 227.705Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.074 229.599L383.712 233.858L385.219 237.171L394.581 232.912L393.074 229.599Z",
    fill: "#5A4020"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M320.001 242.847L316.88 244.267L317.634 245.924L320.754 244.504L320.001 242.847Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M326.996 241.665L323.875 243.084L324.629 244.741L327.75 243.321L326.996 241.665Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M335.605 235.749L332.484 237.168L333.238 238.825L336.358 237.405L335.605 235.749Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M342.6 234.566L339.479 235.985L340.233 237.642L343.354 236.222L342.6 234.566Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M351.209 228.65L348.088 230.069L348.842 231.726L351.962 230.306L351.209 228.65Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M316.774 252.314L313.653 253.733L314.407 255.39L317.528 253.97L316.774 252.314Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M326.89 249.711L323.769 251.13L324.523 252.787L327.644 251.367L326.89 249.711Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M335.499 243.795L332.378 245.215L333.131 246.871L336.252 245.452L335.499 243.795Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M348.736 239.773L345.615 241.192L346.368 242.849L349.489 241.429L348.736 239.773Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M360.465 232.437L357.344 233.856L358.098 235.513L361.219 234.093L360.465 232.437Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M313.547 261.779L310.426 263.199L311.18 264.856L314.301 263.436L313.547 261.779Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M326.784 257.757L323.663 259.177L324.417 260.833L327.537 259.414L326.784 257.757Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M338.513 250.422L335.392 251.841L336.146 253.498L339.267 252.078L338.513 250.422Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M354.871 244.979L351.75 246.399L352.504 248.056L355.625 246.636L354.871 244.979Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M369.721 236.224L366.6 237.644L367.354 239.3L370.475 237.88L369.721 236.224Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.035 260.361L305.586 277.398L319.152 307.218L356.601 290.18L343.035 260.361Z",
    fill: "#D4C5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.948 273.139L305.586 277.398L310.108 287.338L319.47 283.079L314.948 273.139Z",
    fill: "#E8DCC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.697 273.613L310.214 279.292L314.736 289.232L327.219 283.553L322.697 273.613Z",
    fill: "#F0E6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.572 276.927L341.209 281.187L347.239 294.44L356.601 290.18L350.572 276.927Z",
    fill: "#B8A890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.586 283.554L341.103 289.233L344.118 295.859L356.601 290.18L353.586 283.554Z",
    fill: "#A89880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 239.065L352.398 256.102L365.963 285.921L403.413 268.884L389.847 239.065Z",
    fill: "#D4C5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 239.065L380.485 243.324L385.007 253.264L394.369 249.005L389.847 239.065Z",
    fill: "#C4B59A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.234 243.798L375.75 249.477L380.272 259.417L392.756 253.738L388.234 243.798Z",
    fill: "#B8A890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.538 265.569L366.176 269.829L372.205 283.082L381.567 278.822L375.538 265.569Z",
    fill: "#B8A890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.794 269.356L372.311 275.035L375.326 281.662L387.809 275.983L384.794 269.356Z",
    fill: "#A89880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19 270.3L314.948 273.139L328.514 302.958L334.755 300.119L321.19 270.3Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.069 271.719L314.948 273.139L328.514 302.958L331.635 301.539L318.069 271.719Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.035 260.361L336.794 263.201L350.359 293.02L356.601 290.18L343.035 260.361Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.914 261.781L336.794 263.201L350.359 293.02L353.48 291.6L339.914 261.781Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.639 253.263L352.398 256.102L365.963 285.921L372.205 283.082L358.639 253.263Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.518 254.682L352.398 256.102L365.963 285.921L369.084 284.501L355.518 254.682Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.485 243.324L374.243 246.164L387.809 275.983L394.051 273.143L380.485 243.324Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.364 244.744L374.243 246.164L387.809 275.983L390.93 274.563L377.364 244.744Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.533 261.308L342.929 268.407L353.48 291.6L369.084 284.501L358.533 261.308Z",
    fill: "#5A4020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.533 261.308L342.929 268.407L344.436 271.72L360.04 264.622L358.533 261.308Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05 266.987L342.929 268.407L353.48 291.6L356.601 290.18L346.05 266.987Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.533 261.308L355.412 262.728L365.963 285.921L369.084 284.501L358.533 261.308Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92 266.041L347.557 270.301L349.065 273.614L358.427 269.355L356.92 266.041Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.934 272.668L350.572 276.927L352.079 280.24L361.441 275.981L359.934 272.668Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.949 279.294L353.586 283.554L355.094 286.867L364.456 282.608L362.949 279.294Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.799 267.461L350.678 268.881L358.215 285.447L361.335 284.027L353.799 267.461Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.688 274.324L357.567 275.744L359.074 279.057L362.195 277.638L360.688 274.324Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.576 275.032L310.214 279.292L314.736 289.231L324.098 284.972L319.576 275.032Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.576 275.032L310.214 279.292L310.967 280.948L320.33 276.689L319.576 275.032Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.774 278.582L310.214 279.292L314.736 289.231L316.296 288.521L311.774 278.582Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.675 276.807L314.115 277.517L318.637 287.456L320.197 286.746L315.675 276.807Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46 279.174L312.098 283.433L312.852 285.09L322.214 280.83L321.46 279.174Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.649 278.819L312.528 280.238L314.035 283.552L317.156 282.132L315.649 278.819Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.234 243.797L378.871 248.057L383.393 257.996L392.756 253.737L388.234 243.797Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.234 243.797L378.871 248.057L379.625 249.713L388.987 245.454L388.234 243.797Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.432 247.347L378.871 248.057L383.393 257.996L384.954 257.286L380.432 247.347Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.333 245.572L382.772 246.282L387.294 256.221L388.855 255.512L384.333 245.572Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.118 247.939L380.755 252.198L381.509 253.855L390.871 249.596L390.118 247.939Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M384.306 247.584L381.185 249.003L382.693 252.317L385.813 250.897L384.306 247.584Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.655 266.044L312.91 310.057L314.417 313.37L411.162 269.358L409.655 266.044Z",
    fill: "#8B7355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.162 269.358L314.417 313.371L315.925 316.684L412.669 272.671L411.162 269.358Z",
    fill: "#7A6245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.717 284.499L333.354 288.759L334.862 292.072L344.224 287.813L342.717 284.499Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.345 286.393L331.741 293.492L334.755 300.119L350.359 293.02L347.345 286.393Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.239 294.439L337.876 298.699L339.384 302.012L348.746 297.753L347.239 294.439Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.982 290.652L334.862 292.072L337.876 298.699L340.997 297.279L337.982 290.652Z",
    fill: "#7A6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.166 267.462L370.804 271.722L372.311 275.035L381.674 270.776L380.166 267.462Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.794 269.356L369.19 276.455L372.205 283.082L387.809 275.983L384.794 269.356Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.688 277.402L375.326 281.662L376.833 284.975L386.196 280.716L384.688 277.402Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.432 273.615L372.311 275.035L375.326 281.662L378.447 280.242L375.432 273.615Z",
    fill: "#7A6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M353.035 207.824L349.914 209.244L351.421 212.557L354.542 211.137L353.035 207.824Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.421 212.557L348.3 213.977L349.808 217.29L352.928 215.871L351.421 212.557Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M357.663 209.717L354.542 211.137L356.049 214.45L359.17 213.031L357.663 209.717Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M356.049 214.45L352.928 215.87L354.436 219.183L357.556 217.764L356.049 214.45Z",
    fill: "#D0D0D0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_1326_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.735 54.0967L285.563 57.9619L287.085 61.1801L295.257 57.3148L293.735 54.0967Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.085 61.1802L282.999 63.1128L286.043 69.5491L290.129 67.6165L287.085 61.1802Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.044 69.5488L281.958 71.4814L285.002 77.9178L289.088 75.9852L286.044 69.5488Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.509 36.7031L322.337 40.5684L323.859 43.7865L332.031 39.9213L330.509 36.7031Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.117 37.9888L332.031 39.9214L335.075 46.3577L339.161 44.4251L336.117 37.9888Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.247 42.4922L339.161 44.4248L342.206 50.8611L346.292 48.9285L343.247 42.4922Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.257 57.3149L287.085 61.1802L293.174 74.0529L301.346 70.1876L295.257 57.3149Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.907 50.2314L293.735 54.0967L301.346 70.1875L309.518 66.3223L301.907 50.2314Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.557 43.1479L300.385 47.0132L309.518 66.3222L317.69 62.457L308.557 43.1479Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.251 42.501L310.079 46.3662L317.69 62.4571L325.862 58.5918L318.251 42.501Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.945 41.8535L319.773 45.7188L325.862 58.5914L334.034 54.7262L327.945 41.8535Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.117 37.9883L327.945 41.8535L334.034 54.7262L342.206 50.8609L336.117 37.9883Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.247 42.492L286.043 69.5488L289.088 75.9852L346.292 48.9284L343.247 42.492Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.206 50.8612L293.174 74.0527L296.218 80.4891L345.25 57.2975L342.206 50.8612Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.164 59.2299L300.304 78.5562L303.348 84.9925L344.208 65.6662L341.164 59.2299Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 67.599L307.434 83.0601L310.479 89.4964L343.167 74.0354L340.122 67.599Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.081 75.9682L314.565 87.564L317.609 94.0003L342.125 82.4045L339.081 75.9682Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.039 84.3369L321.695 92.0674L324.739 98.5037L341.083 90.7732L338.039 84.3369Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.997 92.706L328.825 96.5713L330.347 99.7895L338.519 95.9242L336.997 92.706Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.907 50.2314L293.735 54.0967L295.257 57.3149L303.429 53.4496L301.907 50.2314Z",
    fill: "#FF6B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.557 43.1479L300.385 47.0132L301.907 50.2314L310.079 46.3661L308.557 43.1479Z",
    fill: "#FF8577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.257 57.3149L287.085 61.1802L290.129 67.6165L298.301 63.7513L295.257 57.3149Z",
    fill: "#FF6B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.429 53.4497L295.257 57.3149L298.301 63.7513L306.473 59.886L303.429 53.4497Z",
    fill: "#FF8577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.079 46.3662L301.907 50.2314L304.951 56.6678L313.123 52.8025L310.079 46.3662Z",
    fill: "#FFA094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.473 59.8857L286.043 69.5488L289.088 75.9852L309.518 66.322L306.473 59.8857Z",
    fill: "#FF8577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.123 52.8022L304.951 56.6675L307.995 63.1038L316.167 59.2386L313.123 52.8022Z",
    fill: "#FFB5AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.117 37.9883L327.945 41.8535L334.034 54.7262L342.206 50.8609L336.117 37.9883Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.247 42.4917L335.075 46.3569L338.12 52.7933L346.292 48.928L343.247 42.4917Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.206 50.8608L329.948 56.6587L332.992 63.095L345.25 57.2971L342.206 50.8608Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.164 59.2299L328.906 65.0278L331.95 71.4642L344.208 65.6663L341.164 59.2299Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.122 67.5986L327.864 73.3965L330.909 79.8328L343.167 74.0349L340.122 67.5986Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.081 75.9677L326.823 81.7656L329.867 88.202L342.125 82.4041L339.081 75.9677Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.125 82.4043L325.781 90.1348L328.825 96.5711L345.169 88.8406L342.125 82.4043Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.083 90.7729L332.911 94.6382L334.433 97.8564L342.605 93.9911L341.083 90.7729Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.779 60.5332L292.693 62.4658L294.215 65.684L298.301 63.7514L296.779 60.5332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.429 53.4497L299.343 55.3823L300.865 58.6005L304.951 56.6679L303.429 53.4497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.428,
    height: 84.7925,
    fill: "white",
    transform: "translate(218.416 69) rotate(31.5887)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.779,
    height: 120.026,
    fill: "white",
    transform: "translate(12 372.114) rotate(-22.0033)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.108,
    height: 96.8129,
    fill: "white",
    transform: "translate(263.296 361) rotate(25.249)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.369,
    height: 155.242,
    fill: "white",
    transform: "translate(-112 512.092) rotate(-29.6974)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.946,
    height: 123.946,
    fill: "white",
    transform: "translate(182.134 474.632) rotate(35.6881)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.138,
    height: 155.443,
    fill: "white",
    transform: "translate(104 267.439) rotate(-36.8425)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.8843,
    height: 85.0612,
    fill: "white",
    transform: "translate(17.4879 78.6279) rotate(-22.7577)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 91,
    fill: "white",
    transform: "translate(272 236.692) rotate(-24.4626)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_1326_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 89,
    fill: "white",
    transform: "translate(256 48.3159) rotate(-25.3136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymemory);
export default __webpack_public_path__ + "static/media/mymemory.7587386f04bbc20b02edb16d50998dbd.svg";
export { ForwardRef as ReactComponent };